import { render, staticRenderFns } from "./UOBProposalUpload.vue?vue&type=template&id=1ace0c76&"
import script from "./UOBProposalUpload.vue?vue&type=script&lang=js&"
export * from "./UOBProposalUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports